import { TopProduct } from '@/interfaces/dashboard.interface';
import CommonTable, { TableColumn } from '../common/commonTable/CommonTable';
import ImagePreview from '../common/media/ImagePreview';
import { API_URL_PRODUCT_SERVICE } from '@/api/constant';
import { checkIsExpire, toFixedThree } from '@/utility/helper';
import { ActionConfig } from '@/interfaces/common.interface';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
import { useMemo } from 'react';
import { usePermissions } from '@/hooks/usePermissions';

const TopProducts = ({
  products,
  emptyMessage = 'No products found',
}: {
  products: TopProduct[];
  emptyMessage?: string;
}) => {
  const navigate = useNavigate();
  const { canView } = usePermissions();

  const productActionConfig: Record<string, ActionConfig<TopProduct>> = {
    view: {
      text: 'View',
      onClick: (product) =>
        navigate(`${RoutesLink.productDetail}/${product.productId}`),
      permission: () => canView('product'),
    },
  };

  const actions = useMemo(
    () =>
      Object.values(productActionConfig)
        .filter((action) => action.permission())
        .map(({ permission, ...rest }) => rest),
    [canView],
  );

  const columns: TableColumn<TopProduct>[] = [
    {
      key: 'product',
      header: 'Product',
      render: (item) => {
        const url = item.product.directImageUrl
          ? item?.product.directImageUrl
          : item?.product?.images?.[0]?.url;
        return (
          <ImagePreview
            src={`${API_URL_PRODUCT_SERVICE}/${url}`}
            alt={''}
            text={item.product.name}
          />
        );
      },
      className: 'p-3',
    },
    {
      key: 'price',
      header: 'Price BHD',
      render: (item) => toFixedThree(item?.secondaryPrice || item?.price || 0),
    },
    {
      key: 'stock',
      header: 'Unit Stock',
      render: (item) => item?.secondaryQuantity || 0,
    },
    {
      key: 'stock',
      header: 'CTN Stock',
      render: (item) => item?.primaryQuantity || 0,
    },
    {
      key: 'discount',
      header: 'Discount',
      render: (item) => (
        <span>{checkIsExpire(item?.discountEndDate) ? 'Yes' : 'No'}</span>
      ),
    },
    {
      key: 'ItemId',
      header: 'Item Id',
      render: (item) => <span>{item?.product.inventoryItemId}</span>,
    },
  ];
  return (
    <CommonTable
      columns={columns}
      data={products}
      getItemId={(item) => item.id}
      emptyMessage={emptyMessage}
      minHeight="h-[400px]"
      actions={actions}
    />
  );
};

export default TopProducts;
